<template lang="html">
	<div style="position:absolute;height:100vh">
		<div :class="'hidden-xs-only profiles-card-sm ' + (showList ? 'visible':'hidden')">
			<el-card class="box-card hidden-xs-only" style="height:100%" shadow="always">
				<div slot="header" class="clearfix">
					<i @click="hide" class="el-icon-arrow-left back-arrow"></i>&nbsp;
				</div>
				<div class="spot-notes" v-if="spot">
					<h1>{{ spot.name }}</h1>
					<h2>{{ spot.description }}</h2>
				</div>
				<ProfilesCTA :cta="onPrintCall" :spot="spot"/>
				<div v-if="spot === null" style="height:80vh" v-loading="true"></div>
				<div v-else>
					<ProfileItem v-if="!spot.officeClass.isForeign" v-for="profile of filteredProfiles" :profile="profile" :spot="spot"/>
				</div>
			</el-card> 
			
		</div>
		<div :class="'hidden-sm-and-up profiles-card-xs ' + (showList ? 'visible':'hidden')">
			<el-card class="box-card hidden-sm-and-up" style="height:100%" shadow="always">
				<div slot="header" class="clearfix">
					<i @click="hide" class="el-icon-arrow-left back-arrow"></i>&nbsp;
				</div>
				<div class="spot-notes" v-if="spot">
					<h1>{{ spot.name }}</h1>
					<h2>{{ spot.description }}</h2>
				</div>
				<ProfilesCTA :cta="onPrintCall" :spot="spot"/>
				<div v-if="spot === null" style="height:80vh" v-loading="true"></div>
				<div v-else>
					<ProfileItem v-if="!spot.officeClass.isForeign" v-for="profile of filteredProfiles" :profile="profile" :spot="spot"/>
				</div>
			</el-card>
		</div>
	</div>
</template>
<script>
import ProfileItem from '@/components/ProfileItem.vue';
import ProfilesCTA from '@/components/ProfilesCTA.vue';

export default {
	name: 'ProfilesList',
	props: {
		spot: Object,
		onPrintCall: Function
	},
	computed: {
		filteredProfiles: function () {
			let out = this.spot.profiles.filter(item => { return !(item.isMailgate || item.isBinary); });
			if (out === null || out === undefined) {
				return [];
			}
			return out;
		}
	},
	data: () => ({
		showList: false,
		loading: true
	}),
	created: function () {
		console.log(this.spot);
	},
	methods: {
		recountContentHeight: function () {
			let ch = window.document.getElementById('spot-list-sm-content').offsetHeight,
				wh = window.innerHeight - 200;
			if (wh > ch) {
				this.contentHeight = 'auto';
				return;
			}
			if (ch === 0) {
				this.contentHeight = 'auto';
				return;
			}
			this.contentHeight = (wh) + 'px';
		},
		show: function () {
			this.showList = true;
		},
		hide: function () {
			this.showList = false;
		}
	},
	components: {
		ProfileItem, ProfilesCTA
	}
}
</script>
<style lang="scss" scoped>
.profiles-card-xs {
	position:absolute;
	top:0;
	height:100%;
	width:100vw;
	padding:0;
	box-sizing:border-box;
	.spot-notes {
		h1 {
			font-size:1.2em;
			font-weight:bold;
			margin-bottom:0.5em;
			color: #409eff;
		}
		h2 {
			font-size:0.9em;
			color: #777;
			line-height:1.5em;
		}
	}
	.back-arrow {
		position:absolute;
		font-size:2em;
		margin-top:-0.18em;
		cursor:pointer;
	}
	&.visible {
		transition: margin-left .3s linear;
		margin:0;
		dislay:none;
	}
	&.hidden {
		transition: margin-left .3s linear;
		margin-left:100vw;
		display:block;
	}
}
.profiles-card-sm {
	position:absolute;
	top:0;
	height:100%;
	width:$profiles-width;
	padding:1.5em;
	box-sizing:border-box;
	.spot-notes {
		h1 {
			font-size:1.2em;
			font-weight:bold;
			margin-bottom:0.5em;
			color: #409eff;
		}
		h2 {
			font-size:0.9em;
			color: #777;
			line-height:1.5em;
		}
	}
	.back-arrow {
		position:absolute;
		font-size:2em;
		margin-top:-0.18em;
		cursor:pointer;
	}
	&.hidden {
		opacity: 0;
		left:0;
		transition: all 0.3s ease-in-out;
		z-index:0;
		.back-arrow {
			transform: rotate(180deg);
			transition: transform 0.3s linear;
		}
	}
	&.visible {
		opacity: 1.0;
		left: $spots-width - 30;
		transition: all 0.3s ease-in-out;
		z-index:$z-index-high;
		.back-arrow {
			transform: rotate(0deg);
			transition: transform 0.3s linear;
		}
	}
}
</style>








